import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { Globals } from '../globals';

@Injectable({
  providedIn: 'root',
})
export class AgentService {
  _headers: HttpHeaders;

  _baseURL: any;

  user: any;

  deviceId: number;

  deviceInfo: any;

  constructor(
    private httpClient: HttpClient,
    private globaols: Globals,
    private deviceService: DeviceDetectorService
  ) {
    this.deviceId = Date.now();
    this.deviceInfo = this.deviceService.getDeviceInfo();
    const devicedetail: any = {
      platform: 'Website',
      browser: this.deviceInfo.browser,
      browserVersion: this.deviceInfo.browser_version,
      osVersion: this.deviceInfo.os_version,
      deviceId: this.deviceInfo.device + this.deviceInfo.deviceType,
      appVersion: '',
      ipAddress: '',
      macAddress: '',
    };
    this.user = this.globaols.getUser();
    this._headers = new HttpHeaders()
      .set('content-type', 'application/json')
      .set('User_Agent', JSON.stringify(devicedetail));
    this._baseURL = environment.apiUrl;
  }

  get headers() {
    return this._headers.set('Access-Token', this.globaols.getUser().token);
  }

  _getDetails(obj: any): Observable<any> {
    return this.httpClient.post(
      `${this._baseURL}api/ims/v1/partner/details`,
      obj,
      { headers: this.headers }
    );
  }

  _update(obj: any): Observable<any> {
    return this.httpClient.put(
      `${this._baseURL}api/ims/v1/partner/update`,
      obj,
      { headers: this.headers }
    );
  }

  _getAgentList(obj: any): Observable<any> {
    return this.httpClient.post(
      `${this._baseURL}api/ims/v1/partner/get/partner/agents`,
      obj,
      { headers: this.headers }
    );
  }

  _deleteAgent(obj: any): Observable<any> {
    return this.httpClient.put(
      `${this._baseURL}api/ims/v1/partner/delete/agent`,
      obj,
      { headers: this.headers }
    );
  }

  _signUpAgent(obj: any): Observable<any> {
    return this.httpClient.post(
      `${this._baseURL}api/ims/v1/partner/signup`,
      obj,
      { headers: this.headers }
    );
  }

  updateAgentState(obj: any): Observable<any> {
    return this.httpClient.put(
      `${this._baseURL}api/ims/v1/partner/update/partner/state`,
      obj,
      { headers: this.headers }
    );
  }
}
